import "./mobile-buttons.css";
import { IoLogoApple, IoLogoGooglePlaystore } from "react-icons/io5";

const MobileButton = ({ type, title, subtitle, color }) => {
  return (
    <button className="mobile-buttons" style={{ borderColor: color }}>
      {type === "apple" && <IoLogoApple className="icon" size={32} color={color}/>}
      {type === "google" && (
        <IoLogoGooglePlaystore className="icon" size={32} color={color} />
      )}
      <div className="col" style={{ color: color }}>
        <span>{title}</span>
        <p>{subtitle}</p>
      </div>
    </button>
  );
};

export default MobileButton;
